export default __webpack_public_path__ + "static/pool-fc9dcd5ffbd5d3fb15567cd79abb116c.jpeg";